import { IDictionary } from '@/utilities/IDictionary';
import PropertyCategoryEnum from './PropertyCategoryEnum';

export const propertyCategoryLabels: IDictionary<string> = {
    [PropertyCategoryEnum.Residential]: 'Residential',
    [PropertyCategoryEnum.Commercial]: 'Commercial',
    [PropertyCategoryEnum.RuralResidential]: 'Rural Residential',
};